import { Step } from "react-joyride";

export const tourStepsMultipleWords = (): Step[] => {
  const steps: Step[] = [
    {
      target: "h1.mb-8",
      content:
        "Multiple Words matches related items that are not the same word, such as Furniture and Couch.",
      disableBeacon: true,
    },
    {
      target: ".game-instructions",
      content:
        "Enter a prompt on the left and its match on the right, then click Add Pair. You can also save a set of pairs to use later.",
    },
    {
      target: ".start-button",
      content:
        "When you have at least one pair, start the game. Connect each prompt to the correct match. Optional timer is above this button.",
    },
  ];

  return steps;
};
